<template>
  <div class="servicio">
    <v-container fluid class="py-0">
      <!-- *************row 1******************* -->
      <v-row id="servicio-open">
        <v-col cols="12" class="pa-0">
          <div class="wrap">
            <div>
              <v-img
                :src="'https://www.mlcpcms.actstudio.xyz/'+service.cover.path"
                class="intro-img-service"
              ></v-img>
            </div>

            <div class="overlay">
              <div class="text-overlay">
                <div>
                  <v-img
                    :src="'https://www.mlcpcms.actstudio.xyz/'+service.iconCover.path"
                    class="d-block mx-auto img-icon-services"
                  ></v-img>
                </div>
                <span class="card-title-mine d-block mt-4 px-2 max-width-text-service">{{service.TituloDeServicio}}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- *************/row 1******************* -->

      <!-- *************row 2******************* -->
      <v-row>
        <v-col cols="12" md="7" class="align-self-center">
          <v-row justify="center">
            <v-col cols="12" md="6" class="justify-content-center">
              <div class="position-relative">
                <p>{{service.generalText}}</p>
              </div>
            </v-col>

            <v-col cols="12" class="text-center">
              <div>
                <v-btn
                  width="250"
                  :to="'/cita/'+service.urlService"
                  color="#330E0E"
                  elevation="0"
                  tile
                >
                  <span class="white--text notUppercase">Consultar</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="5" class="pa-0">
          <div>
            <v-img
              :src="'https://www.mlcpcms.actstudio.xyz/'+service.miniatureCover.path"
              min-height="calc(67vh - 90px)"
            ></v-img>
          </div>
        </v-col>
      </v-row>

      <!-- *************/row 2******************* -->
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    service: {
      cover: {
        path: ""
      },
      miniatureCover:{
        path: ""
      },
      iconCover:{
        path: ""
      }
    },
  }),
  created: function () {
    //traer el servicio
    fetch(
      "https://www.mlcpcms.actstudio.xyz/api/collections/get/servicios?token=16db21f0656450d15b7ee93d559638",
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          filter: {
            urlService: this.$route.params.servicio,
          },
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.service = res.entries[0]))
      .catch((error) => console.log(error.message));
  },
  mounted: function () {
    this.$emit("update", 1);
  },
};
</script>

